/**
 * Proof the trust bar is allowed to show. Every number comes from the course
 * content source (ROB_STORY.credentials), never from a value typed here, so a
 * change to the instructor facts updates the trust bar too.
 *
 * Only reach and credibility facts belong here. No earnings, returns, or
 * student outcome claims (see MarketingManager/docs/ROB-PROFILE-POSITIONING.md).
 */
export type ProofStat = { value: string; label: string };

export const TRUST_BAR_STAT_LABELS = ['students taught', 'Lumibot GitHub stars'];

export function selectTrustBarStats(credentials: ProofStat[]): ProofStat[] {
  return TRUST_BAR_STAT_LABELS.flatMap((label) => {
    const stat = credentials.find((c) => c.label === label);
    if (!stat) {
      // Fail loud, never invent a stand-in number.
      console.error(`TrustBar: proof stat "${label}" is missing from course content`);
      return [];
    }
    return [{ value: stat.value, label: stat.label }];
  });
}
